import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Vue from 'vue';
import VueRouter from 'vue-router';
import layoutHeaderAside from '@/layout/header-aside';
import pageRouter from '@/router/modules/pageRouter'; // 进度条

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store/index';
import util from '@/libs/util.js'; // 路由数据

import routes from './routes'; // fix vue-router NavigationDuplicated

var VueRouterPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(function (err) {
    return err;
  });
};

var VueRouterReplace = VueRouter.prototype.replace;

VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch(function (err) {
    return err;
  });
}; // 固定菜单与路由


import { menuAside, menuHeader } from '@/menu';
import { frameInRoutes } from '@/router/routes'; //模拟动态菜单与路由
// import { permissionMenu, permissionRouter } from '@/mock/permissionMenuAndRouter'
//代码生成器生成的菜单与路由

Vue.use(VueRouter); // 导出路由 在 main.js 里使用

var router = new VueRouter({
  routes: routes
});
var permissionMenu,
    permissionRouter = [];

var fetchPermissionInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var formatRoutes, list, accessMenus, newList, allMenuAside, allMenuHeader;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            //处理动态添加的路由
            formatRoutes = function formatRoutes(routes) {
              var list = [];
              routes.forEach(function (route) {
                var paths = route.path ? route.path.split('/') : null;
                var data = {
                  path: route.path,
                  name: paths ? paths[paths.length - 1] : '',
                  component: route.path == "" ? layoutHeaderAside : function (resolve) {
                    return require(["@/views".concat(route.path)], resolve);
                  },
                  meta: {
                    title: route.name,
                    cache: true
                  },
                  children: route.children
                };

                if (data.children && data.children.length) {
                  data.children = formatRoutes(data.children);
                }

                list.push(data);
              });
              return list;
            };

            list = pageRouter;
            _context.next = 4;
            return store.dispatch('d2admin/permission/generateAccessMenus', list);

          case 4:
            accessMenus = _context.sent;
            newList = formatRoutes(list); //组合代码生成器生成的菜单和路由

            permissionMenu = [].concat(_toConsumableArray(accessMenus), _toConsumableArray(newList));
            permissionRouter = [].concat(_toConsumableArray(list), _toConsumableArray(newList));
            allMenuAside = [].concat(_toConsumableArray(menuAside), _toConsumableArray(accessMenus));
            allMenuHeader = [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenus)); // 动态添加路由

            router.addRoutes(newList); // 处理路由 得到每一级的路由设置

            store.commit('d2admin/page/init', [].concat(_toConsumableArray(frameInRoutes), _toConsumableArray(permissionRouter))); // 设置顶栏菜单

            store.commit('d2admin/menu/headerSet', allMenuHeader); // 设置侧边栏菜单

            store.commit('d2admin/menu/asideSet', allMenuAside); // 初始化菜单搜索功能

            store.commit('d2admin/search/init', allMenuHeader); // 加载上次退出时的多页列表

            store.dispatch('d2admin/page/openedLoad');
            _context.next = 18;
            return Promise.resolve();

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchPermissionInfo() {
    return _ref.apply(this, arguments);
  };
}(); //免校验token白名单


var whiteList = ['/login'];
/**
 * 路由拦截
 * 权限验证
 */

router.beforeEach( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(to, from, next) {
    var token, state;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // 进度条
            NProgress.start(); // 关闭搜索面板

            store.commit('d2admin/search/set', false);
            token = util.cookies.get('token');

            if (!(whiteList.indexOf(to.path) === -1)) {
              _context2.next = 20;
              break;
            }

            if (!(token && token !== 'undefined')) {
              _context2.next = 16;
              break;
            }

            //拉取权限信息
            state = store.state.d2admin.permission.isFetchPermissionInfo;

            if (state) {
              _context2.next = 13;
              break;
            }

            _context2.next = 9;
            return fetchPermissionInfo();

          case 9:
            store.commit('d2admin/permission/setFet', true);
            next(to.path, true);
            _context2.next = 14;
            break;

          case 13:
            next();

          case 14:
            _context2.next = 18;
            break;

          case 16:
            // 将当前预计打开的页面完整地址临时存储 登录后继续跳转
            // 这个 cookie(redirect) 会在登录后自动删除
            util.cookies.set('redirect', to.fullPath); // 没有登录的时候跳转到登录界面

            next({
              name: 'login'
            });

          case 18:
            _context2.next = 21;
            break;

          case 20:
            if (to.name === 'login') {
              // 如果已经登录，则直接进入系统
              if (token && token !== undefined) {
                next(from.path, true);
                NProgress.done();
              } else {
                next();
              }
            } else {
              next();
            }

          case 21:
            NProgress.done();

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  // 进度条
  NProgress.done(); // 需要的信息
  // const app = router.app
  // const { name, params, query } = to
  // 多页控制 打开新的页面

  store.dispatch('d2admin/page/open', to); // 更改标题

  util.title(to.meta.title);
});
export default router;